<div [ngbTooltip]="'HELP_CENTER' | translate" class="nav-link" (click)="sendMessageModal()">
    <i class="far fa-question-circle"></i>
</div>